export default __webpack_public_path__ + "static/media/Background_00146.bcb1045d.png";